/**
 *  PreloaderScene
 *
 *  Created by Legman on 27/03/2016.
 *
 */

import AudioParams from "../AudioParams";
import Common from "../Common";

/**
 * @class
 */
export default class SplashScene extends p3.Scene {
    constructor() {
        super();

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._char1 = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._char2 = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._char3 = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._char4 = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._logo = null;

        /**
         * @type {PIXI.BitmapText | PIXI.Text}
         * @private
         */
        this._titleLabel = null;

        /**
         * @type {p3.Button}
         * @private
         */
        this._playButton = null;

        /**
         * @type {Audio}
         * @private
         */
        this._introSFX = null;
    }

    init() {
        super.init();

        const assets = Common.assets;

        const bg = new PIXI.Sprite(assets.getTexture("ui_splash"));
        this.addChild(bg);

        this._char1 = new PIXI.Sprite(assets.getTexture("ui_char_04a"));
        this._char1.x = Common.STAGE_WIDTH * 0.5 - 420;
        this._char1.y = Common.STAGE_HEIGHT + 34;
        this._char1.scale = new PIXI.Point(-0.74, 0.74);
        this._char1.anchor = new PIXI.Point(0.5, 1);
        this._char1.visible = false;
        this.addChild(this._char1);

        this._char1.blink = new PIXI.Sprite(assets.getTexture("ui_char_04a_blink"));
        this._char1.blink.anchor = new PIXI.Point(0.5, 1);
        this._char1.blink.visible = false;
        this._char1.addChild(this._char1.blink);

        this.blinkAnimation(this._char1);

        this._char2 = new PIXI.Sprite(assets.getTexture("ui_char_04b"));
        this._char2.x = Common.STAGE_WIDTH * 0.5 - 298;
        this._char2.y = Common.STAGE_HEIGHT + 40;
        this._char2.scale = new PIXI.Point(-0.74, 0.74);
        this._char2.anchor = new PIXI.Point(0.5, 1);
        this._char2.visible = false;
        this.addChild(this._char2);

        this._char2.blink = new PIXI.Sprite(assets.getTexture("ui_char_04b_blink"));
        this._char2.blink.anchor = new PIXI.Point(0.5, 1);
        this._char2.blink.visible = false;
        this._char2.addChild(this._char2.blink);

        this.blinkAnimation(this._char2);

        this._char4 = new PIXI.Sprite(assets.getTexture("ui_char_02"));
        this._char4.x = Common.STAGE_WIDTH * 0.5 + 400;
        this._char4.y = Common.STAGE_HEIGHT + 46;
        this._char4.scale = new PIXI.Point(0.74, 0.74);
        this._char4.anchor = new PIXI.Point(0.5, 1);
        this._char4.visible = false;
        this.addChild(this._char4);

        this._char4.blink = new PIXI.Sprite(assets.getTexture("ui_char_02_blink"));
        this._char4.blink.anchor = new PIXI.Point(0.5, 1);
        this._char4.blink.visible = false;
        this._char4.addChild(this._char4.blink);

        this.blinkAnimation(this._char4);

        this._char3 = new PIXI.Sprite(assets.getTexture("ui_char_01"));
        this._char3.x = Common.STAGE_WIDTH * 0.5 + 214;
        this._char3.y = Common.STAGE_HEIGHT + 60;
        this._char3.scale = new PIXI.Point(0.74, 0.74);
        this._char3.anchor = new PIXI.Point(0.5, 1);
        this._char3.visible = false;
        this.addChild(this._char3);

        this._char3.blink = new PIXI.Sprite(assets.getTexture("ui_char_01_blink"));
        this._char3.blink.anchor = new PIXI.Point(0.5, 1);
        this._char3.blink.visible = false;
        this._char3.addChild(this._char3.blink);

        this.blinkAnimation(this._char3);

        this._logo = new PIXI.Sprite(assets.getTexture("logo"));
        this._logo.x = Common.STAGE_WIDTH * 0.5;
        this._logo.y = 94;
        this._logo.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._logo);

        if (language === "ar") {
            this._titleLabel = new PIXI.Text(translate("splash_title"), {
                fontSize: "40px", fontFamily: "Noto Kufi Arabic", fill: 0xFFFFFF, align: "center", padding: 6});
            this._titleLabel.x = Common.STAGE_WIDTH * 0.5;
            this._titleLabel.y = 220;
            this._titleLabel.pivot.x = this._titleLabel.width * 0.5;
            this._titleLabel.pivot.y = this._titleLabel.height * 0.5;
            this.addChild(this._titleLabel);
        } else {
            const holder = new PIXI.Container();
            holder.x = Common.STAGE_WIDTH * 0.5;
            holder.y = 212;
            this.addChild(holder);

            this._titleLabel = new PIXI.BitmapText(translate("splash_title"), font(46, "center"));
            this._titleLabel.tint = 0xFFFFFF;
            this._titleLabel.maxWidth = 340;
            holder.addChild(this._titleLabel);

            holder.pivot.x = holder.width * 0.5;
            holder.pivot.y = holder.height * 0.5;
        }

        let states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_big_out");
        states.over = assets.getTexture("ui_btn_big_over");
        states.down = assets.getTexture("ui_btn_big_down");
        states.icon = assets.getTexture("ui_icon_play");

        this._playButton = new p3.Button(states);
        this._playButton.x = Common.STAGE_WIDTH * 0.5;
        this._playButton.y = Common.STAGE_HEIGHT * 0.5 + 254;
        this._playButton.visible = false;
        this._playButton.overSoundName = "sfx_btn_rollover_00";
        this._playButton.downSoundName = "sfx_btn_press_00";
        this._playButton.signals.click.add(this.onPlayButtonClick, this);
        this.addChild(this._playButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_out");
        states.over = assets.getTexture("ui_btn_over");
        states.down = assets.getTexture("ui_btn_down");
        states.icon = assets.getTexture("ui_icon_sound_on");
        states.iconAlt = assets.getTexture("ui_icon_sound_off");

        this._muteButton = new p3.MuteButton(states);
        this._muteButton.visible = false;
        this._muteButton.interactive = false;
        this._muteButton.overSoundName = "sfx_btn_rollover_00";
        this._muteButton.clickSoundName = "sfx_btn_press_00";
        this.addChild(this._muteButton);
    }

    destroy() {
        this._char1.blinkTween && this._char1.blinkTween.kill();
        this._char2.blinkTween && this._char2.blinkTween.kill();
        this._char3.blinkTween && this._char3.blinkTween.kill();
        this._char4.blinkTween && this._char4.blinkTween.kill();

        this._introSFX && this._introSFX.destroy();

        super.destroy();
    }

    appear() {
        super.appear();

        const params = new AudioParams();
        params.callback = function() {
            Common.audio.playMusic("music_intro_loop_00");
        };
        params.scope = this;

        Common.audio.stopMusic();
        this._introSFX = Common.audio.playSound("music_intro_start_00", params);
    }

    animateIn() {
        this._playButton.scale = new PIXI.Point();
        TweenMax.to(this._playButton.scale, 0.4, {
            delay: 0.4,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [4],
            onStart: function() {
                this._playButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._playButton.interactive = true;
            },
            onCompleteScope: this
        });

        this._muteButton.scale = new PIXI.Point();
        TweenMax.to(this._muteButton.scale, 0.4, {
            delay: 0.4 + 0.06,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._muteButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._muteButton.interactive = true;
            },
            onCompleteScope: this
        });

        this.animateDriver(this._char1, 1, 0);
        this.animateDriver(this._char2, 1, 0.2);
        this.animateDriver(this._char3, -1, 0.1);
        this.animateDriver(this._char4, -1, 0.3);
    }

    /**
     * @param {PIXI.DisplayObject} char
     * @param {number} [direction]
     * @param {number} [delay]
     */
    animateDriver(char, direction = 1, delay = 0) {
        // slide driver
        let to = char.x;
        if (direction === 1) {
            char.x = char.x - 800;
        } else if (direction === -1) {
            char.x = char.x + 800;
        }
        TweenMax.killTweensOf(char);
        TweenMax.to(char, 0.4, {
            delay: delay,
            x: to,
            ease: Back.easeOut,
            easeParams: [1],
            onStart: function() {
                char.visible = true;
            },
            onStartScope: this
        });

        // fade driver
        char.alpha = 0;
        TweenMax.to(char, 0.2, {
            delay: delay,
            alpha: 1,
            ease: Power1.easeInOut
        });

        // bounce driver
        if (direction === 1) {
            char.rotation = -0.14;
        } else if (direction === -1) {
            char.rotation = 0.14;
        }
        TweenMax.to(char, 0.8, {
            delay: delay + 0.16,
            rotation: 0,
            ease: Elastic.easeOut,
            easeParams: [1]
        });
    }

    resize() {
        this.x = (p3.View.width - Common.STAGE_WIDTH) * 0.5;

        this._muteButton.x = (Common.STAGE_WIDTH + p3.View.width) * 0.5 - 100;
        this._muteButton.y = 100;
    }

    update() {
        const input = Common.input;
        if (input.isKeyPressed(32)) {
            this.onPlayButtonClick(null);
        }
    }

    /**
     * @param {PIXI.Sprite} character
     */
    blinkAnimation(character) {
        character.blinkTween = delay(function() {
            character.blink.visible = true;
            character.blinkTween = delay(function() {
                character.blink.visible = false;
                this.blinkAnimation(character);
            }, 0.1, this);

            character.scale.y = 0.734;
            TweenMax.to(character.scale, 0.44, {
                y: 0.74,
                ease: Back.easeOut
            });
        }, 1 + Math.random() * 2, this);
    }

    onPlayButtonClick(event) {
        this._playButton.interactive = false;

        this.signals.next.dispatch(this);

        this._introSFX && this._introSFX.destroy();
        Common.audio.stopMusic();

        Common.audio.playSound("sfx_whistle_rise_00");
        Common.audio.playSound("music_intro_end_00");
    }
}

